import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker, { DatePickerProps } from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import BooleanUtil from 'utils/BooleanUtil';
import codeDataStore from "common/codedata/store/CodeDataStore";
function ContentsContainer() {

	  const location = useLocation();
	  const receivedData = (location.state as any)?.data;
	  const history = useHistory();
  
	  const [totalRowCnt,setTotalRowCnt] = useState(0);
	  const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	  
	  /** 검색조건 */
	  const [authorCode,setAuthorCode] = useState('');
	  const [authorNm,setAuthorNm] = useState('');
	  const [useYn,setUseYn] = useState(Object);
	 
	  //초기 데이터 설정
	  let totalCnt:number = 0;
	  let rowCnt:number = 0;
  
	  //====== 그리드 공통 부 START
	  var ib = ib||{};
	  ib = {
		  //시트 초기화 구문
		  'init':{
			  "Cfg": {
				  "SearchMode": 3,
				 // "PageLength": 20,
				  "AutoRowHeight": 1,
				  "InfoRowConfig": "0",
				  "Alternate":"0"
				  
			  },
			  Def:{
				  Row:{
				  //AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				  }
			  },
			  //틀고정 좌측 컬럼 설정
			  "LeftCols": [
			  {"Header": "No","Name": "SEQ","Width": "90"}
			  ],
			  "Cols": [
				  {"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 1,"CanEdit": "0"},
				  {"Header": "권한코드","Type": "Text","Name": "AUTHOR_CODE","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				  {"Header": "권한이름","Type": "Text","Name": "AUTHOR_NM","TextStyle": 4,"RelWidth": 2,"Align": "Left" ,"CanEdit": "0"}, 
				  {"Header": "메뉴 갯수","Type": "Text","Name": "AUTHOR_MENU_CO","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
				  {"Header": "리소스 갯수","Type": "Text","Name": "AUTHOR_RESRCE_CO","RelWidth": 1,"Align": "Center","CanEdit": "0"},
				  {"Header": "사용자 수","Type": "Text","Name": "AUTHOR_USER_CO","RelWidth": 1,"Align": "Center","CanEdit": "0"},
				  {"Header": "정렬순서","Type": "Text","Name": "SORT_ORDR","RelWidth": 1,"Align": "Center","CanEdit": "0"},
				  {"Header": "사용여부","Type": "Enum","Name": "USE_YN","RelWidth": 1,"CanEdit": 0,"Align": "Center","Enum": "|사용|미사용","EnumKeys": "|1|0"}
				  ]  
		  },
		  //시트 이벤트
		  'event':{
			  onRenderFirstFinish:function (evtParam) {
				  //초기 데이터 로딩
				  doSearch('init');
			  },
			  //시트 더블클릭시 이벤트 처리
			  onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
				  if(evtParam.col == "AUTHOR_NM" ){
					  var sheet = evtParam.sheet;
					  var row = sheet.getFocusedRow();
					  sheet.selectRow( row, 1);
					  let vAUTHOR_ID= row["AUTHOR_ID"];
					  
					  //검색조건 파라미터
					  let searchParam = {
					 	  "AUTHOR_CODE": authorCode,
					 	  "AUTHOR_NM":authorNm,
					 	  "USE_YN":useYn
					   }
					   let dataToSend = {
					 	  searchParam , vAUTHOR_ID
					   }
					  // 다른 페이지로 이동하면서 데이터 전달
					  history.push({
					  pathname: './adm6432',
					  state: { data: dataToSend }
					  });
				  }
				}
  
			  },	  
			  onBeforeDataLoad:function (evtParam) {
				  // 조회 후 로딩 전 발생 이벤트
				  var d = evtParam.data;
				  var _data;
		  
				  // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				  if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
				  _data = JSON.stringify(d.slice(0, 20), null, 2);
				  _data += _data.substring(0, _data.length - 1) + '...\n]';
				  } else {
				  _data = JSON.stringify(d, null, 2);
				  }
				  
			  }
		  },
		  //시트객체 생성
		  'create':function () {
			  let options = this.init;
		  
			  //@ts-ignore
			  options.Events = this.event;
			  //@ts-ignore
			  IBSheet.create({
				  id: 'sheet', // 생성할 시트의 id
				  el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				  options: options, // 생성될 시트의 속성
				  data: this.data // 생성될 시트의 정적데이터
			  });
			  // global 변수 선언
			  //@ts-ignore
			  window.currentPage = -1;
		  },
		  //엑셀 다운로드
		  'exportData':function () {
			  let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			  //@ts-ignore
			  IBSheet.sheet.down2Excel({fileName: "권한관리_"+today+".xlsx"});
		  },
		  //조회 데이터
		  'data':[]
	  }
	  
	  //====== 그리드 공통 부  END
	   
	  //페이지 건수별로 보기 
	  const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			rowCnt = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);		  
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
			
		 }
	  };
	  
	  //====== 그리드 데이터 가지고 오기  START
	  async function doSearch(sAction:string) {
		  let param = {};
		  if(sAction =='search'){
			  
			   param = {
				"AUTHOR_CODE": authorCode,
				"AUTHOR_NM":authorNm,
				"USE_YN":useYn
			  };
  
		  }
		  
		  //파라미터 전송
		  const response:any = await CommonUtil.execute({
			   url:'adm_6431_selectList',
			   data: param
		  })
				  
		  //전체데이터 
		  let result = response.LIST;
  
		  if(result != null){
			  //전체ROW개수 
			  totalCnt = Object.keys(result).length;
			  setTotalRowCnt(Object.keys(result).length);
		  }
		  
		  //데이터 처리
		  ib.data = result;
			// @ts-ignore	
		  sheet.loadSearchData(result);  //data 로딩 처리 
		  // @ts-ignore	
		  sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		  // @ts-ignore	
		 // makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
		  
	  }
	  
	  //====== 그리드 데이터 가지고 오기  END
  
	 
	  //등록 페이지로 이동
	  const pageCreate = function (){
		  let dataToSend = {};
		  // 다른 페이지로 이동하면서 데이터 전달
		  history.push({
		  pathname: './adm6433',
		  state: { data: dataToSend }
		  });
	  }
  
	  //인풋 엔터체크
	  const activeEnter = (e) => {
		  if(e.key === "Enter") {
			  doSearch('search');
		  }
	  }
  
	  
	  // init 
	  React.useEffect(() => {
		 
		  //ib시트 생성
		  ib.create();
  
  
		  //필요한 공통코드 로딩.
		  codeDataStore.read("/common/yesNo", "/common/useYn");
		  
		  
		  return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);		  
		  }
	  },[])
		  

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

				<ul className="fww-brd">
					<li className=""><a href="">홈</a></li>
					<li className=""><a href="">관리자페이지</a></li>
					<li className=""><a href="">시스템관리</a></li>
					<li className=""><a href="">권한관리</a></li>
				</ul>

				<main className="fww-main">
					<h1 className="tx tx-hd2">권한 관리</h1>
					
					<form className="sf sf-1row sf-3col mb30">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">권한 코드</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={authorCode} valueChanged={(value) => setAuthorCode(value)} placeholder={"검색어 입력"} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">권한 이름</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={authorNm} valueChanged={(value) => setAuthorNm(value)} placeholder={"검색어 입력"} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">사용 여부</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<UISelect 
											firstName={"all"} 
											value={useYn}
											valueChanged={(value) => setUseYn(BooleanUtil.toBooleanOrEmpty(value))}
											codeData={codeDataStore.get('/common/useYn')}
										/>	
									</div>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md" data-hz="" type="button" onClick={() =>doSearch('search')}>조회</button>
					</form>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">103</em>건
						</div>
						<div className="hz-root hz-gap5">
						<Button color="gray-o" size="sm" onClick={()=> pageCreate()}>등록</Button>
						<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							{/* <div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div> */}
						</div>
					</div>

					<div id='sheetDiv'>[D] IBSHEET 영역</div>
				
					{/* <div id="pageNavi" className="pg"></div>	 */}

				</main>

			</div>
		</PageContainer>
	);
}
export default ContentsContainer;